import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import GET from "./utils/GET";

import { datadogRum } from "@datadog/browser-rum";

if (GET("environment") !== "development") {
	datadogRum.init({
		applicationId: "4125368a-e69b-4ede-ac48-5d0330cd0e9b",
		clientToken: "pub450fa30082ebfd4866a2c732d44abcb2",
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: "datadoghq.com",
		service: "widget",
		env: GET("environment"),
		// Specify a version number to identify the deployed version of your application in Datadog
		// version: '1.0.0',
		sessionSampleRate: 1,
		sessionReplaySampleRate: 0,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		usePartitionedCrossSiteSessionCookie: true,
		defaultPrivacyLevel: "mask-user-input",
	});
}

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
);
